export const OPTIONS = [
    {
        label: 'Equals',
        value: 'EQUALS',
    },
    {
        label: 'Not Equals',
        value: 'NOT_EQUALS',
    },
    {
        label: 'Greater Than',
        value: 'GREATER_THAN',
    },
    {
        label: 'Less Than',
        value: 'LESS_THAN',
    },
    {
        label: 'Greater Than or Equals',
        value: 'GREATER_THAN_OR_EQUALS',
    },
    {
        label: 'Less Than or Equals',
        value: 'LESS_THAN_OR_EQUALS',
    },
    {
        label: 'Contains',
        value: 'CONTAINS',
    },
    {
        label: 'Not Contains',
        value: 'NOT_CONTAINS',
    },
];

export const WORKSPACE_VARIABLES = [
    {
        _id: 'businesses',
        name: 'Businesses',
        value: 'businesses',
    },
];
